module.exports = __webpack_public_path__ + "img/saif.a555cd58.jpeg";